export const CILIOS_GALLERY_IMAGES = [
  '/images/procedures/cilios-volume-brasileiro.jpeg',
  '/images/procedures/cilios-volume-egipcio.jpeg',
  '/images/procedures/cilios-volume-egipcio-marrom.jpeg',
  '/images/procedures/cilios-volume-sirena.jpeg',
  '/images/procedures/cilios-efeito-fox.jpeg',
  '/images/procedures/cilios-fio-a-fio.jpeg',
  '/images/procedures/cilios-efeito-rimel.jpeg',
  '/images/procedures/cilios-efeito-anime.jpeg',
  '/images/procedures/cilios-lash-lifting-1.jpeg',
  '/images/procedures/cilios-lash-lifting-2.jpeg',
];

const procedurePresentationByName = {
  // Cílios
  'lashlifting': {
    title: 'Lash Lifting',
    category: 'Cílios',
    description: 'Curvatura, nutrição e realce dos cílios naturais para um olhar mais aberto, elegante e com praticidade no dia a dia.',
    images: [
      '/images/procedures/cilios-lash-lifting-1.jpeg',
      '/images/procedures/cilios-lash-lifting-2.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-lash-lifting-1.jpeg',
  },
  'lash lifting': {
    title: 'Lash Lifting',
    category: 'Cílios',
    description: 'Curvatura, nutrição e realce dos cílios naturais para um olhar mais aberto, elegante e com praticidade no dia a dia.',
    images: [
      '/images/procedures/cilios-lash-lifting-1.jpeg',
      '/images/procedures/cilios-lash-lifting-2.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-lash-lifting-1.jpeg',
  },
  'volume brasileiro': {
    title: 'Volume Brasileiro',
    category: 'Cílios',
    description: 'Fios especiais em formato Y proporcionando volume marcante, leveza incomparável e alta durabilidade.',
    images: [
      '/images/procedures/cilios-volume-brasileiro.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-volume-brasileiro.jpeg',
  },
  'volume egipcio': {
    title: 'Volume Egípcio',
    category: 'Cílios',
    description: 'Fios em formato W em tons pretos proporcionando preenchimento sofisticado, alinhamento e olhar marcante.',
    images: [
      '/images/procedures/cilios-volume-egipcio.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-volume-egipcio.jpeg',
  },
  'efeito egipcio marrom': {
    title: 'Efeito Egípcio Marrom',
    category: 'Cílios',
    description: 'Técnica com fios marrons que trazem máxima suavidade, naturalidade e elegância para o olhar.',
    images: [
      '/images/procedures/cilios-volume-egipcio-marrom.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-volume-egipcio-marrom.jpeg',
  },
  'volume egipcio marrom': {
    title: 'Efeito Egípcio Marrom',
    category: 'Cílios',
    description: 'Técnica com fios marrons que trazem máxima suavidade, naturalidade e elegância para o olhar.',
    images: [
      '/images/procedures/cilios-volume-egipcio-marrom.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-volume-egipcio-marrom.jpeg',
  },
  'egipcio marrom': {
    title: 'Efeito Egípcio Marrom',
    category: 'Cílios',
    description: 'Técnica com fios marrons que trazem máxima suavidade, naturalidade e elegância para o olhar.',
    images: [
      '/images/procedures/cilios-volume-egipcio-marrom.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-volume-egipcio-marrom.jpeg',
  },
  'volume sirena': {
    title: 'Volume Sirena',
    category: 'Cílios',
    description: 'Efeito sereia com acabamento delineado e lifting nos cantos externos para um olhar marcante e sofisticado.',
    images: [
      '/images/procedures/cilios-volume-sirena.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-volume-sirena.jpeg',
  },
  'sirena': {
    title: 'Volume Sirena',
    category: 'Cílios',
    description: 'Efeito sereia com acabamento delineado e lifting nos cantos externos para um olhar marcante e sofisticado.',
    images: [
      '/images/procedures/cilios-volume-sirena.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-volume-sirena.jpeg',
  },
  'fox': {
    title: 'Efeito Fox',
    category: 'Cílios',
    description: 'Alongamento estratégico nos cantos externos dos olhos para um visual puxado, sensual e expressivo.',
    images: [
      '/images/procedures/cilios-efeito-fox.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-efeito-fox.jpeg',
  },
  'efeito fox': {
    title: 'Efeito Fox',
    category: 'Cílios',
    description: 'Alongamento estratégico nos cantos externos dos olhos para um visual puxado, sensual e expressivo.',
    images: [
      '/images/procedures/cilios-efeito-fox.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-efeito-fox.jpeg',
  },
  'fox eyes': {
    title: 'Efeito Fox',
    category: 'Cílios',
    description: 'Alongamento estratégico nos cantos externos dos olhos para um visual puxado, sensual e expressivo.',
    images: [
      '/images/procedures/cilios-efeito-fox.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-efeito-fox.jpeg',
  },
  'fio a fio': {
    title: 'Extensão Fio a Fio',
    category: 'Cílios',
    description: 'Aplicação clássica de um fio sintético sobre cada fio natural para um resultado sutil, sofisticado e elegante.',
    images: [
      '/images/procedures/cilios-fio-a-fio.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-fio-a-fio.jpeg',
  },
  'extensao fio a fio': {
    title: 'Extensão Fio a Fio',
    category: 'Cílios',
    description: 'Aplicação clássica de um fio sintético sobre cada fio natural para um resultado sutil, sofisticado e elegante.',
    images: [
      '/images/procedures/cilios-fio-a-fio.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-fio-a-fio.jpeg',
  },
  'efeito rimel': {
    title: 'Efeito Rímel',
    category: 'Cílios',
    description: 'Acabamento encorpado e pontas destacadas que simulam com perfeição o efeito do rímel nos cílios.',
    images: [
      '/images/procedures/cilios-efeito-rimel.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-efeito-rimel.jpeg',
  },
  'anime': {
    title: 'Efeito Anime',
    category: 'Cílios',
    description: 'Estilo moderno e personalizado com alternância de tamanhos para um olhar expressivo e marcante.',
    images: [
      '/images/procedures/cilios-efeito-anime.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-efeito-anime.jpeg',
  },
  'efeito anime': {
    title: 'Efeito Anime',
    category: 'Cílios',
    description: 'Estilo moderno e personalizado com alternância de tamanhos para um olhar expressivo e marcante.',
    images: [
      '/images/procedures/cilios-efeito-anime.jpeg',
    ],
    imageUrl: '/images/procedures/cilios-efeito-anime.jpeg',
  },
  'cilios': {
    title: 'Extensão de Cílios',
    category: 'Cílios',
    description: 'Técnicas que trazem beleza e praticidade para o olhar no dia a dia.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'extensao de cilios': {
    title: 'Extensão de Cílios',
    category: 'Cílios',
    description: 'Técnicas que trazem beleza e praticidade para o olhar no dia a dia.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'cilios manutencao 15 dias': {
    title: 'Manutenção de Cílios (15 dias)',
    category: 'Cílios',
    description: 'Manutenção indicada para preservar o volume e o efeito dos cílios com aparência sempre renovada.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'cilios manutencao 21 dias': {
    title: 'Manutenção de Cílios (21 dias)',
    category: 'Cílios',
    description: 'Revisão completa para recuperar o desenho dos cílios e manter o visual impecável.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'cilios manutencao': {
    title: 'Manutenção de Cílios',
    category: 'Cílios',
    description: 'Manutenção indicada para preservar o volume, alinhamento e durabilidade dos fios com acabamento impecável.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao de cilios': {
    title: 'Manutenção de Cílios',
    category: 'Cílios',
    description: 'Manutenção indicada para preservar o volume, alinhamento e durabilidade dos fios com acabamento impecável.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao cilios': {
    title: 'Manutenção de Cílios',
    category: 'Cílios',
    description: 'Manutenção indicada para preservar o volume, alinhamento e durabilidade dos fios com acabamento impecável.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao de cilios (15 dias)': {
    title: 'Manutenção de Cílios (15 dias)',
    category: 'Cílios',
    description: 'Manutenção indicada para preservar o volume e o efeito dos cílios com aparência sempre renovada.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao de cilios 15 dias': {
    title: 'Manutenção de Cílios (15 dias)',
    category: 'Cílios',
    description: 'Manutenção indicada para preservar o volume e o efeito dos cílios com aparência sempre renovada.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao de cilios (21 dias)': {
    title: 'Manutenção de Cílios (21 dias)',
    category: 'Cílios',
    description: 'Revisão completa para recuperar o desenho dos cílios e manter o visual impecável.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao de cilios 21 dias': {
    title: 'Manutenção de Cílios (21 dias)',
    category: 'Cílios',
    description: 'Revisão completa para recuperar o desenho dos cílios e manter o visual impecável.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao 15 dias': {
    title: 'Manutenção de Cílios (15 dias)',
    category: 'Cílios',
    description: 'Manutenção indicada para preservar o volume e o efeito dos cílios com aparência sempre renovada.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao 21 dias': {
    title: 'Manutenção de Cílios (21 dias)',
    category: 'Cílios',
    description: 'Revisão completa para recuperar o desenho dos cílios e manter o visual impecável.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },
  'manutencao': {
    title: 'Manutenção de Cílios',
    category: 'Cílios',
    description: 'Manutenção indicada para preservar o volume, alinhamento e durabilidade dos fios com acabamento impecável.',
    images: CILIOS_GALLERY_IMAGES,
    imageUrl: CILIOS_GALLERY_IMAGES[0],
  },

  // Sobrancelhas
  'design estrategico': {
    title: 'Design Estratégico',
    category: 'Sobrancelha',
    description: 'Mapeamento facial personalizado para encontrar o formato ideal que harmoniza perfeitamente com os seus traços.',
    images: [
      '/images/procedures/sobrancelha-design-estrategico.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-design-estrategico.jpeg',
  },
  'design com aplicacao de henna ou tintura': {
    title: 'Design Com Aplicação de Henna Ou Tintura',
    category: 'Sobrancelha',
    description: 'Preenchimento e definição com henna ou tintura de alta fixação para destacar e valorizar o formato das sobrancelhas.',
    images: [
      '/images/procedures/sobrancelha-design-henna-1.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-design-henna-1.jpeg',
  },
  'design com henna': {
    title: 'Design Com Aplicação de Henna Ou Tintura',
    category: 'Sobrancelha',
    description: 'Preenchimento e definição com henna ou tintura de alta fixação para destacar e valorizar o formato das sobrancelhas.',
    images: [
      '/images/procedures/sobrancelha-design-henna-1.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-design-henna-1.jpeg',
  },
  'desing com henna': {
    title: 'Design Com Aplicação de Henna Ou Tintura',
    category: 'Sobrancelha',
    description: 'Preenchimento e definição com henna ou tintura de alta fixação para destacar e valorizar o formato das sobrancelhas.',
    images: [
      '/images/procedures/sobrancelha-design-henna-1.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-design-henna-1.jpeg',
  },
  'sobrancelha simples': {
    title: 'Design Estratégico',
    category: 'Sobrancelha',
    description: 'Design personalizado que visa trazer leveza, harmonia e realçar a beleza do seu olhar.',
    images: [
      '/images/procedures/sobrancelha-design-estrategico.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-design-estrategico.jpeg',
  },
  'brow lamination': {
    title: 'Brow Lamination',
    category: 'Sobrancelha',
    description: 'Alinhamento e nutrição dos fios para valorizar o desenho natural das sobrancelhas com acabamento encorpado e sofisticado.',
    images: [
      '/images/procedures/sobrancelha-brow-lamination.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-brow-lamination.jpeg',
  },
  'micropigmentacao': {
    title: 'Micropigmentação Fio a Fio',
    category: 'Sobrancelha',
    description: 'Técnica hiper-realista que desenha fios delicados, corrigindo falhas com máxima naturalidade e longa durabilidade.',
    images: [
      '/images/procedures/sobrancelha-micropigmentacao.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-micropigmentacao.jpeg',
  },
  'micropigmentacao fio a fio': {
    title: 'Micropigmentação Fio a Fio',
    category: 'Sobrancelha',
    description: 'Técnica hiper-realista que desenha fios delicados, corrigindo falhas com máxima naturalidade e longa durabilidade.',
    images: [
      '/images/procedures/sobrancelha-micropigmentacao.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-micropigmentacao.jpeg',
  },
  'sobrancelha tintura': {
    title: 'Design Com Aplicação de Henna Ou Tintura',
    category: 'Sobrancelha',
    description: 'Coloração suave dos fios para um acabamento definido e sofisticado.',
    images: [
      '/images/procedures/sobrancelha-design-henna-1.jpeg',
    ],
    imageUrl: '/images/procedures/sobrancelha-design-henna-1.jpeg',
  },

  // Maquiagem
  'makeup social': {
    title: 'Makeup Social',
    category: 'Maquiagem',
    description: 'Produção completa para formaturas, casamentos, eventos e ensaios, com produtos de alta durabilidade e acabamento luxuoso.',
    images: [
      '/images/procedures/maquiagem-social-1.jpeg',
      '/images/procedures/maquiagem-social-2.jpeg',
      '/images/procedures/maquiagem-social-3.jpeg',
    ],
    imageUrl: '/images/procedures/maquiagem-social-1.jpeg',
  },
  'maquiagem social': {
    title: 'Makeup Social',
    category: 'Maquiagem',
    description: 'Produção completa para formaturas, casamentos, eventos e ensaios, com produtos de alta durabilidade e acabamento luxuoso.',
    images: [
      '/images/procedures/maquiagem-social-1.jpeg',
      '/images/procedures/maquiagem-social-2.jpeg',
      '/images/procedures/maquiagem-social-3.jpeg',
    ],
    imageUrl: '/images/procedures/maquiagem-social-1.jpeg',
  },
  'makeup glow': {
    title: 'Makeup Glow',
    category: 'Maquiagem',
    description: 'Pele iluminada, suave e radiante que realça a beleza natural sem transformar seus traços.',
    images: [
      '/images/procedures/maquiagem-glow.jpeg',
    ],
    imageUrl: '/images/procedures/maquiagem-glow.jpeg',
  },
  'maquiagem glow': {
    title: 'Makeup Glow',
    category: 'Maquiagem',
    description: 'Pele iluminada, suave e radiante que realça a beleza natural sem transformar seus traços.',
    images: [
      '/images/procedures/maquiagem-glow.jpeg',
    ],
    imageUrl: '/images/procedures/maquiagem-glow.jpeg',
  },
  'maquiagem': {
    title: 'Makeup Social',
    category: 'Maquiagem',
    description: 'Produções completas personalizadas para festas, formaturas e ocasiões especiais.',
    images: [
      '/images/procedures/maquiagem-social-1.jpeg',
      '/images/procedures/maquiagem-social-2.jpeg',
      '/images/procedures/maquiagem-social-3.jpeg',
    ],
    imageUrl: '/images/procedures/maquiagem-social-1.jpeg',
  },

  // Limpeza
  'limpeza de pele': {
    title: 'Limpeza de Pele Profunda',
    category: 'Limpeza',
    description: 'Higienização profunda com extração de cravos, desintoxicação e hidratação para uma pele renovada e com viço.',
    images: [
      '/images/procedures/limpeza-de-pele-profunda.jpeg',
    ],
    imageUrl: '/images/procedures/limpeza-de-pele-profunda.jpeg',
  },
  'limpeza de pele profunda': {
    title: 'Limpeza de Pele Profunda',
    category: 'Limpeza',
    description: 'Higienização profunda com extração de cravos, desintoxicação e hidratação para uma pele renovada e com viço.',
    images: [
      '/images/procedures/limpeza-de-pele-profunda.jpeg',
    ],
    imageUrl: '/images/procedures/limpeza-de-pele-profunda.jpeg',
  },
};

const procedureDisplayNameByKey = {
  'brow lamination': 'Brow Lamination',
  cilios: 'Cílios',
  'extensao de cilios': 'Extensão de Cílios',
  'cilios manutencao': 'Manutenção de Cílios',
  'cilios manutencao 15 dias': 'Cílios Manutenção 15 Dias',
  'cilios manutencao 21 dias': 'Cílios Manutenção 21 Dias',
  'manutencao de cilios': 'Manutenção de Cílios',
  'manutencao de cilios (15 dias)': 'Manutenção de Cílios (15 dias)',
  'manutencao de cilios 15 dias': 'Manutenção de Cílios (15 dias)',
  'manutencao de cilios (21 dias)': 'Manutenção de Cílios (21 dias)',
  'manutencao de cilios 21 dias': 'Manutenção de Cílios (21 dias)',
  'manutencao cilios': 'Manutenção de Cílios',
  'manutencao 15 dias': 'Manutenção de Cílios (15 dias)',
  'manutencao 21 dias': 'Manutenção de Cílios (21 dias)',
  'manutencao': 'Manutenção de Cílios',
  lashlifting: 'Lash Lifting',
  'lash lifting': 'Lash Lifting',
  'volume brasileiro': 'Volume Brasileiro',
  'volume egipcio': 'Volume Egípcio',
  'volume egipcio marrom': 'Efeito Egípcio Marrom',
  'egipcio marrom': 'Efeito Egípcio Marrom',
  'efeito egipcio marrom': 'Efeito Egípcio Marrom',
  'volume sirena': 'Volume Sirena',
  sirena: 'Volume Sirena',
  'fio a fio': 'Extensão Fio a Fio',
  'extensao fio a fio': 'Extensão Fio a Fio',
  'efeito rimel': 'Efeito Rímel',
  fox: 'Efeito Fox',
  'efeito fox': 'Efeito Fox',
  'fox eyes': 'Efeito Fox',
  anime: 'Efeito Anime',
  'efeito anime': 'Efeito Anime',
  'design estrategico': 'Design Estratégico',
  'design com aplicacao de henna ou tintura': 'Design Com Aplicação de Henna Ou Tintura',
  'design com henna': 'Design Com Aplicação de Henna Ou Tintura',
  'desing com henna': 'Design Com Aplicação de Henna Ou Tintura',
  'limpeza de pele': 'Limpeza de Pele Profunda',
  'limpeza de pele profunda': 'Limpeza de Pele Profunda',
  maquiagem: 'Makeup Social',
  'maquiagem social': 'Makeup Social',
  'makeup social': 'Makeup Social',
  'maquiagem glow': 'Makeup Glow',
  'makeup glow': 'Makeup Glow',
  micropigmentacao: 'Micropigmentação Fio a Fio',
  'micropigmentacao fio a fio': 'Micropigmentação Fio a Fio',
  'sobrancelha simples': 'Design Estratégico',
  'sobrancelha tintura': 'Design Com Aplicação de Henna Ou Tintura',
};

export const PROCEDURE_CATEGORIES = [
  { key: 'all', label: 'Todos os Procedimentos', icon: '✨' },
  { key: 'Cílios', label: 'Cílios', icon: '👁️' },
  { key: 'Sobrancelha', label: 'Sobrancelhas', icon: '✨' },
  { key: 'Maquiagem', label: 'Maquiagem', icon: '💄' },
  { key: 'Limpeza', label: 'Limpeza & Facial', icon: '🌸' },
];

export const fallbackProcedures = [
  // Cílios
  { id: 10, nome: 'Lash Lifting', categoria: 'Cílios', ativo: 1, valor_padrao: 110 },
  { id: 13, nome: 'Volume Brasileiro', categoria: 'Cílios', ativo: 1, valor_padrao: 130 },
  { id: 14, nome: 'Volume Egípcio', categoria: 'Cílios', ativo: 1, valor_padrao: 140 },
  { id: 21, nome: 'Efeito Egípcio Marrom', categoria: 'Cílios', ativo: 1, valor_padrao: 140 },
  { id: 22, nome: 'Volume Sirena', categoria: 'Cílios', ativo: 1, valor_padrao: 150 },
  { id: 17, nome: 'Efeito Fox', categoria: 'Cílios', ativo: 1, valor_padrao: 140 },
  { id: 15, nome: 'Extensão Fio a Fio', categoria: 'Cílios', ativo: 1, valor_padrao: 120 },
  { id: 16, nome: 'Efeito Rímel', categoria: 'Cílios', ativo: 1, valor_padrao: 130 },
  { id: 18, nome: 'Efeito Anime', categoria: 'Cílios', ativo: 1, valor_padrao: 140 },
  { id: 24, nome: 'Manutenção de Cílios (15 dias)', categoria: 'Cílios', ativo: 1, valor_padrao: 80 },
  { id: 25, nome: 'Manutenção de Cílios (21 dias)', categoria: 'Cílios', ativo: 1, valor_padrao: 90 },

  // Sobrancelhas
  { id: 8, nome: 'Design Estratégico', categoria: 'Sobrancelha', ativo: 1, valor_padrao: 45 },
  { id: 19, nome: 'Design Com Aplicação de Henna Ou Tintura', categoria: 'Sobrancelha', ativo: 1, valor_padrao: 60 },
  { id: 11, nome: 'Brow Lamination', categoria: 'Sobrancelha', ativo: 1, valor_padrao: 120 },
  { id: 12, nome: 'Micropigmentação Fio a Fio', categoria: 'Sobrancelha', ativo: 1, valor_padrao: 350 },

  // Maquiagem
  { id: 1, nome: 'Makeup Social', categoria: 'Maquiagem', ativo: 1, valor_padrao: 150 },
  { id: 20, nome: 'Makeup Glow', categoria: 'Maquiagem', ativo: 1, valor_padrao: 150 },

  // Limpeza
  { id: 7, nome: 'Limpeza de Pele Profunda', categoria: 'Limpeza', ativo: 1, valor_padrao: 130 },
];

const normalizeKey = (value) =>
  (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export const formatProcedureName = (value = '') => {
  const normKey = normalizeKey(value);
  if (procedureDisplayNameByKey[normKey]) return procedureDisplayNameByKey[normKey];
  const cleanKey = normKey.replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();
  if (procedureDisplayNameByKey[cleanKey]) return procedureDisplayNameByKey[cleanKey];
  if (cleanKey.includes('manutencao') && (cleanKey.includes('cilio') || cleanKey.includes('lash'))) {
    if (cleanKey.includes('21')) return 'Manutenção de Cílios (21 dias)';
    if (cleanKey.includes('15')) return 'Manutenção de Cílios (15 dias)';
    return 'Manutenção de Cílios';
  }
  return value;
};

const resolveProcedurePresentation = (serviceName) => {
  const normKey = normalizeKey(serviceName);
  if (procedurePresentationByName[normKey]) {
    return procedurePresentationByName[normKey];
  }

  const cleanKey = normKey.replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();
  if (procedurePresentationByName[cleanKey]) {
    return procedurePresentationByName[cleanKey];
  }

  if (cleanKey.includes('manutencao') && (cleanKey.includes('cilio') || cleanKey.includes('lash'))) {
    if (cleanKey.includes('21')) {
      return procedurePresentationByName['cilios manutencao 21 dias'] || procedurePresentationByName['manutencao de cilios'];
    }
    if (cleanKey.includes('15')) {
      return procedurePresentationByName['cilios manutencao 15 dias'] || procedurePresentationByName['manutencao de cilios'];
    }
    return procedurePresentationByName['manutencao de cilios'];
  }

  return {};
};

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatProcedurePrice = (value) => {
  const numericValue = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numericValue) || numericValue <= 0) return null;
  return brlFormatter.format(numericValue);
};

export const getProcedurePresentation = (service) => {
  const presentation = resolveProcedurePresentation(service?.nome);
  const rawPrice = service?.valor_padrao;
  const hasRawPrice = rawPrice !== null && rawPrice !== undefined && `${rawPrice}`.trim() !== '';
  const parsedPrice = hasRawPrice ? Number(rawPrice) : NaN;
  const hasPrice = Number.isFinite(parsedPrice) && parsedPrice > 0;
  const formattedPrice = hasPrice ? brlFormatter.format(parsedPrice) : null;

  const images = presentation.images && presentation.images.length > 0
    ? presentation.images
    : (presentation.imageUrl ? [presentation.imageUrl] : ['/images/procedures/sobrancelha-design-estrategico.jpeg']);

  return {
    id: service.id,
    title: presentation.title || formatProcedureName(service.nome),
    description:
      service.descricao ||
      presentation.description ||
      'Atendimento personalizado com foco em acabamento, conforto e resultado natural.',
    images,
    imageUrl: images[0],
    category: service.categoria || presentation.category || 'Outros',
    price: hasPrice ? parsedPrice : null,
    formattedPrice,
    ativo: service.ativo,
  };
};

export const getFallbackProcedures = () => fallbackProcedures.map(getProcedurePresentation);

